import store from "../../Store/configureStore";
import { strToFloat } from "../../Util/util";
import { getInfoForRole, getWagePlusBenefitsForRole } from "./retrainCalculations";
const lodash = require("lodash");

/**
 * Returns a fraction number representing reduction in productivity.
 */
export const getFracProdLoss = () => {
  const state = store.getState();
  let codingTimeA = lodash.get(state, "costs.prodLossDetails.coding-time-a");
  let codingTimeB = lodash.get(state, "costs.prodLossDetails.coding-time-b");

  if (!codingTimeA || codingTimeA < 0) {codingTimeA = 0}
  if (!codingTimeB || codingTimeB < 0) {codingTimeB = 0}

  if (codingTimeA === codingTimeB) {
    return 0
  }

  return (strToFloat(codingTimeA) - strToFloat(codingTimeB)) / strToFloat(codingTimeB);
};

/**
 * Returns a number representing coder productivity loss per day
 */
export const getCoderProdLossPerDay = () => {
  const state = store.getState();
  let workingHourPerDay = lodash.get(state, "costs.prodLossDetails.working-hours-per-day");
  let coderNumber = lodash.get(getInfoForRole("coder"), "number");
  const coderWagePlusBen = getWagePlusBenefitsForRole("coder");

  if (!workingHourPerDay || workingHourPerDay < 0) {workingHourPerDay = 0}
  if (!coderNumber || coderNumber < 0) {coderNumber = 0}

  if (coderWagePlusBen && getFracProdLoss()) {
    return coderNumber * coderWagePlusBen * getFracProdLoss() * workingHourPerDay;
  } else {
    return 0;
  }
};

/**
 * Returns a number representing total productivity loss with min break-in period.
 */
export const getProdLossWithMinBreakIn = () => {
  const state = store.getState();
  let minBreakIn = lodash.get(state, "costs.prodLossDetails.min-break-in-period");
  let workDaysPerMonth = lodash.get(state, "costs.prodLossDetails.working-days-per-month");

  if (!minBreakIn || minBreakIn < 0) {minBreakIn = 0}
  if (!workDaysPerMonth || workDaysPerMonth < 0) {workDaysPerMonth = 0}

  if (getCoderProdLossPerDay()) {
    return minBreakIn * workDaysPerMonth * getCoderProdLossPerDay();
  } else {
    return 0;
  }
};

/**
 * Returns a number representing total productivity loss with max break-in period.
 */
export const getProdLossWithMaxBreakIn = () => {
  const state = store.getState();
  let maxBreakIn = lodash.get(state, "costs.prodLossDetails.max-break-in-period");
  let workDaysPerMonth = lodash.get(state, "costs.prodLossDetails.working-days-per-month");

  if (!maxBreakIn || maxBreakIn < 0) {maxBreakIn = 0}
  if (!workDaysPerMonth || workDaysPerMonth < 0) {workDaysPerMonth = 0}

  if (getCoderProdLossPerDay()) {
    return maxBreakIn * workDaysPerMonth * getCoderProdLossPerDay();
  } else {
    return 0;
  }
};